var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1235.68 201.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #01ac83;\n      }\n\n      .cls-2 {\n        fill: #313d39;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.01,95.68c0-32.11,18.64-46.61,42.88-46.61,15.33,0,27.96,6.42,35.42,18.44,7.25-12.02,19.89-18.44,35.42-18.44,24.23,0,42.88,14.5,42.88,46.61v58.41h-24.65v-58.41c0-16.78-8.7-23.62-20.71-23.62s-20.51,7.04-20.51,23.62v58.41h-24.65v-58.41c0-16.57-8.91-23.62-20.71-23.62s-20.71,6.84-20.71,23.62v58.41h-24.65v-58.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.66,102.93c0-31.07,22.78-53.86,55.1-53.86s54.69,22.78,54.69,53.86v8.7h-83.89c3.31,14.91,14.71,22.79,29.21,22.79,10.98,0,19.06-3.11,24.23-9.74h26.31c-7.66,19.47-26.31,32.11-50.54,32.11-32.31,0-55.1-22.79-55.1-53.86ZM486.35,91.95c-3.94-13.67-15.12-20.51-28.59-20.51s-24.65,7.04-28.59,20.51h57.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.82,101.89c0-35.01,26.1-52.82,50.96-52.82,14.71,0,26.93,6.21,34.18,17.61V7.02h24.65v95.08c0,33.14-22.37,54.69-54.48,54.69s-55.31-22.37-55.31-54.89ZM602.95,102.93c0-18.02-12.01-30.86-30.04-30.86s-30.24,12.84-30.24,30.86,12.22,30.86,30.24,30.86,30.04-12.84,30.04-30.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M636.46,22.14c0-9.53,6.84-16.57,16.36-16.57s16.36,7.04,16.36,16.57-6.84,16.36-16.36,16.36-16.36-6.84-16.36-16.36ZM640.39,51.77h24.65v102.33h-24.65V51.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M676.38,95.68c0-32.11,18.64-46.61,42.88-46.61,15.33,0,27.96,6.42,35.42,18.44,7.25-12.02,19.89-18.44,35.42-18.44,24.23,0,42.88,14.5,42.88,46.61v58.41h-24.65v-58.41c0-16.78-8.7-23.62-20.71-23.62s-20.51,7.04-20.51,23.62v58.41h-24.65v-58.41c0-16.57-8.91-23.62-20.71-23.62s-20.71,6.84-20.71,23.62v58.41h-24.65v-58.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M839.56,103.97c0-32.52,22.78-54.89,55.31-54.89s54.48,21.75,54.48,54.69v50.33h-22.58v-20.09c-6.21,15.12-20.09,22.79-36.25,22.79-24.86,0-50.96-17.81-50.96-52.82ZM924.7,102.93c0-18.02-12.01-30.86-30.04-30.86s-30.24,12.84-30.24,30.86,12.22,30.86,30.24,30.86,30.04-12.84,30.04-30.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M983.28,132.11h28.18v24.67h-28.18c-6.81,0-12.98-2.75-17.45-7.22-4.47-4.47-7.22-10.64-7.22-17.45V15.5h24.67v36.28h28.18v22.36h-28.18v57.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1018.03,102.93c0-31.07,22.78-53.86,55.1-53.86,27.76,0,48.06,16.78,53.03,41.01h-24.86c-4.35-10.98-14.71-18.02-28.17-18.02-18.02,0-30.24,12.84-30.24,30.86s12.22,30.86,30.24,30.86c13.46,0,23.82-7.04,28.17-18.02h24.86c-4.97,24.24-25.27,41.01-53.03,41.01-32.31,0-55.1-22.79-55.1-53.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1134.6,7.02h24.65v59.04c6.84-10.98,17.4-16.99,30.45-16.99,23.62,0,45.99,15.33,45.99,51.78v53.24h-24.65v-53.24c0-19.47-10.36-28.79-25.89-28.79s-25.89,9.74-25.89,28.79v53.24h-24.65V7.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.64,40.32h-20.16c-11.13,0-20.16,9.03-20.16,20.16v20.16h31.18c5.05,0,9.14-4.09,9.14-9.14v-31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.8,0h0c-11.13,0-20.16,9.03-20.16,20.16v20.16h40.32v-20.16c0-11.13-9.03-20.16-20.16-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.28,80.64v-20.16c0-11.13-9.03-20.16-20.16-20.16h-20.16v31.18c0,5.05,4.09,9.14,9.14,9.14h31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.96,161.28h20.16c11.13,0,20.16-9.03,20.16-20.16v-20.16h-31.18c-5.05,0-9.14,4.09-9.14,9.14v31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.28,80.64v40.32h20.16c11.13,0,20.16-9.03,20.16-20.16h0c0-11.13-9.03-20.16-20.16-20.16h-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.8,201.6h0c11.13,0,20.16-9.03,20.16-20.16v-20.16h-40.32v20.16c0,11.13,9.03,20.16,20.16,20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.32,120.96v20.16c0,11.13,9.03,20.16,20.16,20.16h20.16v-31.18c0-5.05-4.09-9.14-9.14-9.14h-31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,100.8h0c0,11.13,9.03,20.16,20.16,20.16h20.16v-40.32h-20.16c-11.13,0-20.16,9.03-20.16,20.16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogo);
export default __webpack_public_path__ + "static/media/img-logo.40b49e2a1c2ddab631dff960d0c16f50.svg";
export { ForwardRef as ReactComponent };